// src/presentation/pages/ClinicalExamination/sections/ScreeningRequiredSection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface ScreeningRequiredSectionProps {
  isScreeningRequired: boolean | null;
  onChange: (value: boolean) => void;
}

export const ScreeningRequiredSection: React.FC<
  ScreeningRequiredSectionProps
> = ({ isScreeningRequired, onChange }) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.screeningRequired.title")}
        </CardTitle>
        <p className="text-sm text-gray-500">
          {t("clinicalSections.screeningRequired.question")}
        </p>
      </div>
      <div>
        <RadioGroup
          value={isScreeningRequired?.toString()}
          onValueChange={(val) => onChange(val === "true")}
          className="flex gap-6"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="true" id="screening-yes" />
            <Label
              htmlFor="screening-yes"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.yes")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="false" id="screening-no" />
            <Label
              htmlFor="screening-no"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.no")}
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
